/**
 * Dynamic module configuration
 * Defines which modules are loaded conditionally based on page content
 * Separates data (configuration) from behavior (callbacks and DOM access)
 */

export const dynamicModulesConfig = [
  {
    selector: '.gallery',
    js: `${window.location.origin}/js/lightbox.js`,
    css: `${window.location.origin}/css/glightbox.css`,
    thenJs: 'initGallery',
    thenCss: null,
  },
  {
    selector: '.product-gallery',
    js: `${window.location.origin}/js/lightbox.js`,
    css: `${window.location.origin}/css/glightbox.css`,
    thenJs: 'initProductGallery',
    thenCss: null,
  },
  {
    selector: '.contact-form',
    js: `${window.location.origin}/js/contact.js`,
    css: null,
    thenJs: null,
    thenCss: null,
  },
];
